module.exports = __webpack_public_path__ + "img/symbol_8.2d581652.png";